const { populate } = require('@/functions/objects');
const { toBool, toInt, toNullableInt, toNullableString } = require('@/functions/transform');

/**
 * @constructor
 *
 * @param {{}} properties
 */
const AutoRedeemProfile = function (properties = {}) {
    /**
     * @type {boolean}
     */
    this.enabled = true;

    /**
     * @type {number|null}
     */
    this.ID = null;

    /**
     * @type {?string}
     */
    this.description = null;

    /**
     * This property does not exist in the back office yet, but it's supported if we add it in future.
     *
     * If the order contains this number of tickets or less we will auto redeem them all when scanned.
     *
     * @type {number}
     */
    this.maxTicketsToRedeem = 1;

    /**
     * This property does not exist in the back office yet, but it's supported if we add it in future.
     *
     * If false we will only auto redeem if the order contains only one line of tickets.
     * If true we can auto redeem tickets from multiple lines.
     *
     * @type {boolean}
     */
    this.redeemMultipleLines = false;

    /**
     * @type {number|null}
     */
    this.maxMinutesBeforeEventStarts = null;

    /**
     * @type {boolean}
     */
    this.redeemMembersWhenScanned = false;

    populate(this, properties);
};

AutoRedeemProfile.prototype = {
    getHydrationMap() {
        return {
            description: toNullableString,
            enabled: toBool,
            ID: {
                field: ['ID', 'autoRedeemProfileID'],
                transform: toInt,
            },
            maxMinutesBeforeEventStarts: toNullableInt,
            maxTicketsToRedeem: toInt,
            redeemMembersWhenScanned: toBool,
            redeemMultipleLines: toBool,
        };
    },
};

module.exports = AutoRedeemProfile;
